import styled from "styled-components";

import { SidebarNavigationItemPopover } from "@/components/layout/Sidebar/SidebarNavigation/SidebarNavigationItemPopover";
import { SIDEBAR_NAVIGATION_ITEM_CLASS } from "@/components/layout/Sidebar/SidebarNavigation/sidebar-navigation-item.consts";
import { sidebarNavigationItemCSS } from "@/components/layout/Sidebar/SidebarNavigation/sidebar-navigation-item.styles";
import { NavLink } from "@/components/ui/NavLink";
import { Icon } from "@/components/ui-deprecated";

const SidebarNavigationItemStyled = styled(NavLink)`
    ${sidebarNavigationItemCSS};
`;

type Props = {
    title: string;
    icon: string;
    path: string;
    sidebarCollapsed: boolean;
    onClick?: () => void;
};

const SidebarNavigationItem = (props: Props) => {
    const { title } = props;

    let content = (
        <SidebarNavigationItemStyled to={props.path} onClick={props.onClick} className={SIDEBAR_NAVIGATION_ITEM_CLASS}>
            <Icon icon={props.icon} />
            <span className={"title"}>{title}</span>
        </SidebarNavigationItemStyled>
    );

    if (props.sidebarCollapsed) {
        content = (
            <SidebarNavigationItemPopover trigger={"hover"} placement={"right"} overlay={title}>
                <div>{content}</div>
            </SidebarNavigationItemPopover>
        );
    }

    return content;
};

export { SidebarNavigationItem };
